const button = {
    style: {},
    base: 'transition-all duration-300 rounded relative outline-none',
    fontSize: {
        default: 'text-sm',
        sm: 'text-sm',
        xs: 'text-xm'
    },
    color: {
        default: 'bg-primary text-white hover:bg-primary-dark',
        default_link: 'text-primary hover:text-primary-dark',
        green: 'bg-green-600 text-white hover:bg-green-500',
        green_link: 'text-green-600 hover:text-green-500',
        gray: 'bg-gray-200 text-gray-800 hover:text-black',
        gray_link: 'text-gray-200 hover:text-gray-300',
        disabled: 'bg-gray-200 text-gray-800 hover:text-black',
        disabled_link: 'text-gray-200 hover:text-gray-300',
        white: 'bg-white text-black hover:bg-gray-100',
        white_border: 'bg-white text-black hover:bg-gray-100 border border-gray-200',
        white_link: 'text-white hover:text-gray-100',
        link: 'text-gray-800 hover:text-black',
        delete: 'bg-red-600 hover:bg-red-800 text-white',
        delete_link: 'text-red-600 hover:text-red-800',
        red: 'bg-red-600 hover:bg-red-800 text-white',
    },
    padding: {
        "2xl": "px-12 py-8",
        xl: "px-12 py-6",
        lg: "px-8 py-4",
        none: "",
        normal: "px-8 py-3",
        semi: "px-6 py-2",
        sm: "px-6 py-1",
        sm2: "px-6 py-2",
        xs: "px-4 py-1",
    }
}

for ( let color in button.color ) {
    button.style[color] = button.base + ' ' + button.color[color] + ' ' + button.padding.normal;
    for ( let padding in button.padding ) {
        button.style[`${color}_${padding}`] = button.base + ' ' + button.color[color] + ' ' + button.padding[padding];
    }
}

export default button;